export default __webpack_public_path__ + "static/media/thunderstruck.504e008e.png";